import { render, staticRenderFns } from "./ActionCenterPanel.vue?vue&type=template&id=59c8d0e5&scoped=true"
import script from "./ActionCenterPanel.vue?vue&type=script&lang=js"
export * from "./ActionCenterPanel.vue?vue&type=script&lang=js"
import style0 from "./ActionCenterPanel.vue?vue&type=style&index=0&id=59c8d0e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8d0e5",
  null
  
)

export default component.exports